import React from "react";
import PropTypes from "prop-types";
import { cn } from "../../lib/utils";

/**
 * AppLayoutV3 - the new portal shell grid.
 *
 *   [ aside (full-height) | column( header? + content + footer? ) ]
 *
 * Pure layout: the `aside` slot is rendered first (full height, left), and the right
 * column stacks an optional `header`, the scrollable `children` content, and an
 * optional `footer`. The aside owns its own responsive behaviour (desktop navy rail +
 * mobile off-canvas drawer), so AppLayoutV3 stays a dumb container.
 *
 * Route-aware shells (per the layout matrix) are expressed by what the consumer passes:
 *  - nav-shell:     aside = nav AsideBar,     showHeader = true,  footer = none
 *  - stepper-shell: aside = stepper AsideBar, showHeader = false, footer = creation footer
 *  - bare:          aside = none,             showHeader = false, footer = none
 */
export function AppLayoutV3({
  aside,
  header,
  footer,
  children,
  showHeader = true,
  className = "",
  contentClassName = "",
  footerClassName = "",
}) {
  return (
    <div className={cn("h-screen flex overflow-hidden bg-page", className)}>
      {aside}

      <div className="flex flex-col flex-1 min-w-0 h-full">
        {showHeader && header}

        <main className={cn("flex-1 overflow-y-auto", contentClassName)}>
          {children}
        </main>

        {footer && (
          <footer className={cn("flex-shrink-0", footerClassName)}>
            {footer}
          </footer>
        )}
      </div>
    </div>
  );
}
AppLayoutV3.propTypes = {
  aside: PropTypes.node,
  header: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
  showHeader: PropTypes.bool,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  footerClassName: PropTypes.string,
};
